<template>
  <div id="app">
    <!-- Navigation -->
    <section-header />

    <!-- Main content -->
    <router-view :mobile="isMobile"/>

    <!-- Footer -->
    <section-footer />

    <!-- Social & Legal -->
    <section-sub-footer />
    
    <!-- button to jump to top -->
    <div class="jumptoTop" :class="{'show': buttonJump}">
      <a href="#" @click="jumptoTop"></a>
    </div>
  </div>
</template>

<script>
import SectionHeader from '@/components/Header'
import SectionFooter from '@/components/Footer'
import SectionSubFooter from '@/components/SubFooter'
import VueScrollTo from 'vue-scrollto'
export default {
  name: 'app',
  components: {
    SectionHeader,
    SectionFooter,
    SectionSubFooter,
    VueScrollTo
  },
  data () {
    return {
      ticking: false,
      lastPositionScroll: 0,
      buttonJump: false,
      isMobile: ''
    }
  },
  methods: {
    jumptoTop () {
      VueScrollTo.scrollTo('body', 400)
    },
    setStickyClass (positionScroll) {
      if (positionScroll >= 80) {
        this.buttonJump = true
      } else {
        this.buttonJump = false
      }
    },
    checkMobile () {
      this.isMobile = window.innerWidth < 1024
    }
  },
  computed: {
  },
  created () {
    window.addEventListener('scroll', (e) => {
      this.lastPositionScroll = window.scrollY
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.setStickyClass(this.lastPositionScroll)
          this.ticking = false
        })
      }
      this.ticking = true
    })
    this.checkMobile()
    // this.$forceUpdate()
    // size of viewport on resize
    window.addEventListener('resize', () => {
      this.checkMobile()
    })
  },
  mounted () {
    this.$bus.$emit('is-mobile', this.isMobile)
  }
}
</script>

<style lang="sass">
// import main sass file
@import 'sass/main.scss';

</style>



// WEBPACK FOOTER //
// src/App.vue